module.exports = [
	{
		"label": "Cape Cod",
		"value": "capecod",
		"state": "MA"
	},
	{
		"label": "Greenwich",
		"value": "greenwich",
		"state": "CT"
	},
	{
		"label": "The Hamptons",
		"value": "hamptons",
		"state": "NY"
	},
	{
		"label": "Houston",
		"value": "houston",
		"state": "TX"
	},
	{
		"label": "New York City",
		"value": "nyc",
		"state": "NY"
	},
	{
		"label": "Palm Beach",
		"value": "palmbeach",
		"state": "FL"
	},
	{
		"label": "Greater Los Angeles",
		"value": "Los-Angeles-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Monterey Peninsula",
		"value": "Monterey-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Greater Pasadena",
		"value": "Pasadena-Real-Estate",
		"state": "CA"
	},
	{
		"label": "San Francisco Bay Area",
		"value": "San-Francisco-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Santa Barbara",
		"value": "Santa-Barbara-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Santa Fe",
		"value": "Santa-Fe-Real-Estate",
		"state": "NM"
	},
	{
		"label": "Santa Ynez Valley",
		"value": "Santa-Ynez-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Sonoma - Napa Wine Country",
		"value": "Sonoma-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Greater Ventura",
		"value": "Ventura-Real-Estate",
		"state": "CA"
	},
	{
		"label": "Wellington",
		"value": "wellington",
		"state": "FL"
	}
];


//////////////////
// WEBPACK FOOTER
// ./public/json/regions/all-regions.json
// module id = 6236
// module chunks = 0